import { motion, AnimatePresence } from 'framer-motion'
import ArticleCard from './ArticleCard'
import type { Article } from '../../data/articles'
import { useT } from '../../i18n/LocaleContext'

export default function BlogGrid({ articles }: { articles: Article[] }) {
  const { t } = useT()
  return (
    <section className="relative max-w-6xl mx-auto px-6 pb-28">
      <div className="flex items-end justify-between mb-8">
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs uppercase tracking-[0.2em] text-ink-500 font-semibold"
        >
          {t('blog.allArticlesTitle')}
        </motion.h2>
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs text-ink-500"
        >
          {t('blog.allArticlesCaption')}
        </motion.span>
      </div>

      <motion.div
        layout
        className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        <AnimatePresence mode="popLayout">
          {articles.map((a, i) => (
            <motion.div
              key={a.id}
              layout
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            >
              <ArticleCard article={a} delay={i * 0.05} />
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>

      {articles.length === 0 && (
        <div className="py-20 text-center text-ink-500">
          {t('blog.emptyState')}
        </div>
      )}
    </section>
  )
}
